// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { TGetSuggestionRequest, TGetSuggestionModel, IMappers, TGetSuggestionResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetSuggestionResponseSchema } from '../../entities/suggestions_query_string/GetSuggestionResponseSchema';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetSuggestionModel(parameters: TGetSuggestionRequest): TGetSuggestionModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'text-search',
    pathApi: '/v2/get-suggestion/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IGetSuggestionOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TGetSuggestionRequest;
}

export async function fetchGetSuggestion<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetSuggestionOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetSuggestionResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetSuggestionModel(parameters),
    config,
  )) as FetchResponse<TGetSuggestionResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetSuggestionResponseSchema, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetSuggestionResponse>;
}
